<template>
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="registration-title">
          <div v-if="FormInputs.IndividualLabels || FormInputs.BusinessLabels">
            Association Information and Communication Preferences
          </div>
          <div v-if="FormInputs.NonProfitLabels">Communication Preferences</div>
        </div>
      </div>
      <div
        v-if="
          FormInputs.IndividualOrganization || FormInputs.BusinessOrganization
        "
        class="col-lg-12 col-md-12 col-sm-12 col-xs-12"
      >
        <!-- <label v-if="FormInputs.IndividualLabels">
                    Please select all of the professional organizations of which you are a member.
                </label> -->
        <label> Please select all of your professional affiliations. </label>
        <div
          v-for="(value, key) in CheckboxBusiness"
          class="form-check"
          v-if="FormInputs.BusinessOrganization"
        >
          <label class="form-check-label">
            <input
              :value="key"
              v-model="Account.Organizations.List"
              class="form-check-input"
              type="checkbox"
            />
            {{ key }}
          </label>
        </div>
        <div
          v-for="(value, key) in CheckboxIndividual"
          class="form-check"
          v-if="FormInputs.IndividualOrganization"
        >
          <label class="form-check-label">
            <input
              :value="key"
              v-model="Account.Organizations.List"
              class="form-check-input"
              type="checkbox"
            />
            {{ key }}
          </label>
        </div>
        <div
          class="form-group"
          v-if="Account.Organizations.List.indexOf('Other') >= 0"
        >
          <p>
            Please enter any other professional organizations you are associated
            with separated by semicolon(;).
          </p>
          <input
            type="text"
            v-model="Account.Organizations.Others"
            class="form-control"
          />
        </div>
      </div>
      <!-- <div v-if="FormInputs.IndividualOrganization || FormInputs.BusinessOrganization" class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="section_div">
                    <img src="../../../static/img/divider.png" class="divider_img">
                </div>
            </div> -->
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 div_bottom">
        <label
          class="label-heading"
          v-if="
            FormInputs.IndividualOrganization || FormInputs.BusinessOrganization
          "
        >
          Communication Preferences
        </label>
        <p class="no-margin-bot">Please confirm communication preferences.</p>
        <div class="form-check">
          <label class="form-check-label">
            <input
              class="form-check-input"
              v-model="Account.ToBeContactedAsVolunteer"
              type="checkbox"
            />
            I would like to be contacted if there are volunteer opportunities in
            my area.
          </label>
          <label class="form-check-label">
            <input
              class="form-check-input"
              v-model="Account.ToReceiveNewsLetter"
              type="checkbox"
            />
            I would like email updates from OneSight EssilorLuxottica Foundation.
          </label>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="registration-title">
          <div>How do you plan on serving those patients? (check all that apply)</div>
        </div>
        
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 div_bottom">
        <div class="form-check">
          <label class="form-check-label">
            <input
              class="form-check-input"
              value="Serve walk ins and sporadic referrals in my office"
              v-model="Account.HowDoYouPlanOnServingThosePatient"
              type="checkbox"
            />
            Serve walk ins and sporadic referrals in my office
          </label>
          <br/>
          <label class="form-check-label">
            <input
              class="form-check-input"
              value="Host a vision event(s)"
              v-model="Account.HowDoYouPlanOnServingThosePatient"
              type="checkbox"
            />
            Host a vision event(s)
          </label>
          <br/>
          <label class="form-check-label">
            <input
              class="form-check-input"
              value="Partner with a local non profit or school to receive their referrals in my office"
              v-model="Account.HowDoYouPlanOnServingThosePatient"
              type="checkbox"
            />
            Partner with a local non profit or school to receive their referrals in my office
          </label>
          <br/>
          <label class="form-check-label">
            <input
              class="form-check-input"
              value="Volunteer at local clinics, health fairs, or vision events"
              v-model="Account.HowDoYouPlanOnServingThosePatient"
              type="checkbox"
            />
            Volunteer at local clinics, health fairs, or vision events
          </label>
          <br/>
          <label class="form-check-label">
            <input
              class="form-check-input"
              value="I’m not sure"
              v-model="Account.HowDoYouPlanOnServingThosePatient"
              type="checkbox"
            />
            I’m not sure
          </label>
        </div>
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="registration-title">
          <div>Changing Life through Lenses® Frame Collection</div>
        </div>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 div_bottom">
        <p class="no-margin-bot">
          Would you like to order the <b>free</b> Changing Life through Lenses®
          Frame Collection? <br /><a
            href="https://drive.google.com/file/d/1Z3S39DYqB5org6MLswUeDu7I6owNYQC9/view?usp=sharing"
            target="_blank"
            >Learn more</a
          >
        </p>
        <label class="radio form-check-label input-space-right"
          ><input
            v-model="Account.IsOrderFrameKit"
            type="radio"
            name="EverWornGlasses"
            value="true"
          />
          Yes, send me the free Frame Collection!<br /><small v-if="this.Account.IsOrderFrameKit == 'true'"
            >Great! Your Frame Collection will be ordered as soon as you activate your account.</small
          ></label
        >
        <br />
        <label class="radio form-check-label input-space-right"
          ><input
            type="radio"
            v-model="Account.IsOrderFrameKit"
            name="EverWornGlasses"
            value="false"
          />
          No, thanks.<br /><small v-if="this.Account.IsOrderFrameKit == 'false'"
            >If you change your mind, you can always order later from the My
            Account page.</small
          ></label
        >
        <br />
      </div>
    </div> -->
  </div>
</template>
<script>
export default {
  props: ["Account", "CheckboxBusiness", "CheckboxIndividual", "FormInputs"],
  created() {
    var referral = sessionStorage.getItem('referralCode')
    if (referral === 'teamvision') {
      this.Account.Organizations.List.push('TeamVision')
    }
    if (this.FormInputs.IndividualOrganization || this.FormInputs.NonProfitOrganization) this.Account.IsOrderFrameKit = null;
  },
};
</script>



// WEBPACK FOOTER //
// AssociationAndCommunication.vue?6259afaa